import { DEFAULT_RIBBON_HALFTONE_MATERIAL, SUBTLE_RIBBON_INTERACTION } from "../interaction";
import { LANDING_ENDCAP_ZOOM, LINE_SPACING, MATCHED_IDLE_SPEED, PAPER, REVEAL_SPACING, STANDARD_END, STANDARD_START, } from "./shared";
/** Careers makes the ribbon read as a shared working field, which tightens
 * into a clear opening when the live roles area is reached. */
export const CAREERS_PRESET = {
    id: "careers",
    roles: ["settle"],
    mobileBreakpoint: 900,
    palette: "primary-v2",
    shape: "line",
    halftone: DEFAULT_RIBBON_HALFTONE_MATERIAL,
    interaction: SUBTLE_RIBBON_INTERACTION,
    curveProfile: {
        viewportSpan: 0.42, xCheckpoints: [0.2, 0.72, 0.48], bendWindows: [0.08, 0.4, 0.62, 0.9],
        mobile: { viewportSpan: 0.3, xCheckpoints: [0.18, 0.68, 0.48] },
    },
    initialStateId: "career-field",
    states: [
        {
            id: "career-field", background: PAPER, zoom: 0.74, center: [0.44, 0.48],
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            rotationDeg: -78, lineExtent: 0.68, turbulence: 0.18, spacing: REVEAL_SPACING,
            speed: MATCHED_IDLE_SPEED, dither: 1, spatialColor: 0.22, twistRetention: 0.88,
            fanSpread: 0.022, twistSpread: 0.045, horizontalStretch: 1.6, unravel: 0.72,
            curveStrength: 0.82, curveProgress: 0.12, mobile: { zoom: 0.48, horizontalStretch: 1.22 },
        },
        {
            id: "career-openings", background: PAPER, zoom: 0.68, center: [0.54, 0.5],
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            rotationDeg: -88, lineExtent: 0.6, turbulence: 0.09, spacing: LINE_SPACING,
            speed: MATCHED_IDLE_SPEED, dither: 1, spatialColor: 0.1, twistRetention: 0.94,
            fanSpread: 0.01, twistSpread: 0.018, horizontalStretch: 1.1, unravel: 0.25,
            curveStrength: 0.2, curveProgress: 0.62, mobile: { zoom: 0.46, lineExtent: 0.8 },
        },
    ],
    steps: [
        {
            role: "settle",
            stateId: "career-openings",
            start: STANDARD_START,
            end: STANDARD_END,
        },
    ],
};
//# sourceMappingURL=careers.js.map